export class Religion{
    public  ReligionID : Number;
    public  ReligionName : string;
}